import { useNavigate, useParams } from "react-router-dom";
import { CheckCircle } from "lucide-react";
import { getCurrentClientConfig } from "config/clientConfig";
import { useTranslation } from "context/LanguageContext";
import { getSavedOrder } from "services/orderTrackingStorage";
import OrderPageLayout from "features/orders/components/OrderPageLayout";

export default function OrderConfirmationPage() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const savedOrder = getSavedOrder(getCurrentClientConfig().tenantId, orderId);

  return (
    <OrderPageLayout>
      <section className="bg-white rounded-xl shadow-sm border p-8 text-center">
        <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
        <h1 className="text-2xl font-bold text-gray-900">{t("orderPlaced")}</h1>
        <p className="mt-2 text-gray-600">{t("orderNumber")}: #{orderId}</p>
        {!savedOrder && (
          <p className="mt-4 text-amber-700">{t("trackingUnavailable")}</p>
        )}
        <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
          <button
            disabled={!savedOrder}
            onClick={() => navigate(`/orders/${orderId}`)}
            className="px-5 py-3 bg-blue-600 text-white rounded-lg disabled:opacity-50"
          >
            {t("trackOrder")}
          </button>
          <button
            onClick={() => navigate("/")}
            className="px-5 py-3 border border-gray-300 rounded-lg text-gray-700"
          >
            {t("continueShopping")}
          </button>
        </div>
      </section>
    </OrderPageLayout>
  );
}
